//@ts-nocheck
import { Box, Loader, Spacer, Text } from '@jfs/ui-new'
import { Chart as ChartJS, registerables } from 'chart.js'
import debounce from 'lodash/debounce'
import * as React from 'react'
import { FC, useEffect, useState } from 'react'
import { Bar, Line } from 'react-chartjs-2'
import { useLazyApiData, useStores } from '../../../data/store'
import { getChartData } from '../../../util/util'
import styles from '../styles'
import { CheckboxList } from './CheckboxList'
import { externalTooltipHandler } from './ExternalToolTip'
import { GraphHeader } from './GraphHeader'
import { GraphTittle } from './GraphTittle'
ChartJS.register(...registerables)

const Graph: FC = () => {
  const {
    getSegmentedByData,
    fromDate,
    dateValue,
    fetchInsightsRecord,
    getGraphPrefrences,
    getGraphData,
    selectedTab,
    triggerRefresh,
    showByPercentage,
    txnsType,
    durationType,
    segmentedVs,
    segmentedBy,
    mid,
    xAxisData,
    updateXaxisData,
  } = useStores((root) => ({
    getSegmentedByData: root.insights.getSegmentedByData,
    getGraphData: root.insights.getGraphData,
    fetchInsightsRecord: root.insights.fetchInsightsRecord,
    getGraphPrefrences: root.insights.getGraphPrefrences,
    txnsType: root.insights.graphPrefrences.transactions,
    segmentedBy: root.insights.graphPrefrences.segmentedBy,
    segmentedVs: root.insights.graphPrefrences.segmentedVs,
    durationType: root.insights.graphPrefrences.durationType,
    fromDate: root.insights.graphPrefrences.selectedDate.fromDate,
    dateValue: root.insights.graphPrefrences.dateValue,
    selectedTab: root.insights.getSelectedTab(),
    triggerRefresh: root.insights.triggerRefresh,
    showByPercentage: root.insights.graphPrefrences.showByPercentage,
    mid: root.user.selectedMid,
    xAxisData: root?.insights?.graphPrefrences.xAxis,
    getxAxisDataLength: root?.insights?.graphPrefrences.xAxis.length,
    getXaxisTicks: root.insights.getXaxisTicks,
    updateXaxisData: root.insights.updateXaxisData,
  }))

  const segmentedByData = getSegmentedByData()
  const [fetchInsightsRecordApi, { state: fetchInsightsRecordApiState }] = useLazyApiData(fetchInsightsRecord)

  const prefrences = getGraphPrefrences()
  const [reloadGraph, setReloadGraph] = React.useState(false)

  useEffect(() => {
    if (fetchInsightsRecordApiState === 'fulfilled') {
      setReloadGraph(true)
      setTimeout(() => {
        setReloadGraph(false)
      }, 100)
    }
  }, [fetchInsightsRecordApiState])

  const filteredchartData = getGraphData()
  const firstUpdate = React.useRef(true)

  const callApi = React.useCallback(
    debounce((merchantId: any) => {
      if (selectedTab !== 2 && merchantId?.length > 0) {
        fetchInsightsRecordApi(prefrences.toJSON(), merchantId, false)
      }
    }, 50),
    [],
  )

  useEffect(() => {
    if (firstUpdate.current) {
      return
    }
    if (mid) {
      mid?.length > 0 && callApi(mid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    fromDate,
    selectedTab,
    fetchInsightsRecordApi,
    txnsType,
    segmentedVs,
    segmentedBy,
    durationType,
    prefrences,
    triggerRefresh,
    callApi,
  ])

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
    }
    if (selectedTab !== 2 && mid) {
      fetchInsightsRecordApi(prefrences.toJSON(), mid, false)
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mid])
  const [height, setHeight] = useState(0)
  const [width, setWidth] = useState(0)

  const chartData = getChartData(filteredchartData, prefrences, xAxisData, segmentedByData)
  const getGraphView = () => {
    // if (showByPercentage && !isValidPercentageData) {
    //   return renderEmptyView
    // }
    const yaxisTicks = [0]
    const maxValue = Number(prefrences.maxValY) < 10 ? 10 : Number(prefrences.maxValY)
    const minValue = Math.ceil(maxValue / 10)
    for (let i = 1; i < 11; i++) {
      yaxisTicks.push(minValue * i)
    }

    const handleTooltip = (context: any) => {
      return externalTooltipHandler(context)
    }

    const options = (isBar: boolean) => ({
      maintainAspectRatio: false,
      responsive: true,
      title: {
        display: false,
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          external: handleTooltip,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
          display: true,
          stacked: isBar,
        },
        y: {
          grid: {
            display: false,
          },
          display: true,
          stacked: isBar,
        },
      },
    })
    return (
      <Box f={1}>
        <GraphTittle tittle={getTitle[prefrences.transactions]} />
        <Box
          f={1}
          onLayout={(obj) => {
            setHeight(obj?.nativeEvent?.layout?.height ?? 0)
            setWidth(obj?.nativeEvent?.layout?.width ?? 0)
          }}>
          {!reloadGraph && (
            <>
              {prefrences.segmentedVs.length === 0 && (
                <Line
                  data={chartData}
                  translate={'no'}
                  options={options(false)}
                  id="canvas"
                  height={height}
                  width={width}
                />
              )}
              {prefrences.segmentedVs.length > 0 && (
                <Bar
                  data={chartData}
                  translate={'no'}
                  options={options(true)}
                  id="canvas"
                  fill={'true'}
                  height={height}
                  width={width}
                />
              )}
            </>
          )}
        </Box>
      </Box>
    )
  }

  const renderEmptyView = (
    <Box flex={1} justifyContent="center" alignItems="center" margin={40}>
      <Text fontSize={24} fontFamily="jioType-medium" color="BRAND_COLOR_GRAY_2">
        {'No Data Available'}
      </Text>
      <Spacer direction="vertical" size={20} />
      <Text fontSize={12} fontFamily="jioType-medium" color="BRAND_COLOR_GRAY_2" textAlign="center" lineHeight={22}>
        {'There is no transaction data available for the selected time period or segment'}
      </Text>
    </Box>
  )

  const getLoader = (
    <Box flex={1} justifyContent="center">
      <Loader type="large" color={'BLUE'} />
    </Box>
  )

  const getTitle: any = {
    Count: `Transaction Count ${showByPercentage ? '(%)' : ''}`,
    Value: `Transaction Value (${showByPercentage ? '%' : 'Rs.'})`,
  }
  return (
    <Box flex={1} height={'100%'}>
      <Box {...styles.graphView.container}>
        <GraphHeader tittle={'Show By:'} dateValue={dateValue} />
        <Box flex={1} flexDirection="column">
          <Box flex={1} overflowX="auto">
            {(fetchInsightsRecordApiState === 'fulfilled' || !fetchInsightsRecordApiState) &&
              chartData?.datasets?.length > 0 &&
              getGraphView()}
            {(fetchInsightsRecordApiState === 'fulfilled' || !fetchInsightsRecordApiState) &&
              chartData?.datasets?.length === 0 &&
              renderEmptyView}
            {(fetchInsightsRecordApiState === 'pending' || reloadGraph) && getLoader}
          </Box>
        </Box>

        {/*    {prefrences.durationType === 'Hourly' &&
          fetchInsightsRecordApiData &&
          Object.keys(fetchInsightsRecordApiData).length !== 0 && <BottomLine themes={themes} />} */}

        {(fetchInsightsRecordApiState === 'fulfilled' || !fetchInsightsRecordApiState) &&
          prefrences.segmentedVs.length !== 0 && (
            <CheckboxList checkboxData={xAxisData} setCheckboxData={updateXaxisData} />
          )}
      </Box>
    </Box>
  )
}

export { Graph }
